module.exports = __webpack_public_path__ + "static/portfolio-2-266bf4eb0c00f74dae0c00e4ab6c6937.jpg";